/* Back Door collection grid (sections/bd-collection-grid.liquid).
   Presentation only - filtering, sorting and the AJAX re-render stay in
   Dawn's facets.js. This file:
   1. Density: 3/4/5 buttons set data-density on .bd-collection (outside the
      grid facets.js replaces), remembered in localStorage for every
      collection. CSS decides how many columns actually fit.
   2. Quick pills: after facets.js re-renders the grid, copy the pills from
      the same section HTML it just fetched, so their active state follows
      the sidebar filters. No extra request, no client-side filtering.
      Filter pills (brand pages) are sent through facets.js renderPage, so a
      pill is just another native filter change (AJAX, URL, back/forward).
   3. Sticky filter rail: only while the rail fits under the sticky header;
      otherwise it scrolls with the page (no nested scroll area).
   4. Mobile filter sheet (<990px, styled in section-bd-collection.css):
      group headings expand inline (MenuDrawer's slide-in sub-screens are
      skipped), selected counts per group and on FILTER, and the action bar
      reads "Clear" / "View N products" - all from the real form state and
      Dawn's own #ProductCount, refreshed after every facets.js update.
   5. Size rows (collection grids, and the homepage Collection Tabs via
      .bd-size-rows - nothing else runs there): marks a row .is-overflowing only when its values really
      don't fit the card, and stores the slide distance/duration the CSS
      hover reveal uses (distance / SIZE_REVEAL_SPEED = one constant px/s).
      Re-measured on resize, density change and after facets.js re-renders;
      short apparel rows never get the reveal.
   6. On-device overflow check: open any collection URL with #bd-overflow
      to outline every element wider than the viewport and show
      scrollWidth / clientWidth in a corner badge (no effect otherwise). */
(function () {
  var STORAGE_KEY = 'bd-collection-density';
  var wide = window.matchMedia('(min-width: 1400px)');
  var desktop = window.matchMedia('(min-width: 1200px)');
  var railQuery = window.matchMedia('(min-width: 990px)');

  function maxColumns() {
    if (wide.matches) return 5;
    if (desktop.matches) return 4;
    return 3;
  }

  function syncPressed(root) {
    var shown = Math.min(parseInt(root.dataset.density, 10) || 4, maxColumns());
    root.querySelectorAll('[data-density-option]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(parseInt(button.dataset.densityOption, 10) === shown));
    });
  }

  function initDensity(root) {
    syncPressed(root);
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-density-option]');
      if (!button || !root.contains(button)) return;
      root.dataset.density = button.dataset.densityOption;
      try {
        localStorage.setItem(STORAGE_KEY, button.dataset.densityOption);
      } catch (e) {}
      syncPressed(root);
    });
    [wide, desktop].forEach(function (query) {
      query.addEventListener('change', function () {
        syncPressed(root);
      });
    });
  }

  // Keep the active pill inside the horizontal row (mobile) without
  // scrolling the page itself.
  function revealActivePill(list) {
    var active = list && list.querySelector('.bd-collection__pill.is-active');
    if (!active || list.scrollWidth <= list.clientWidth) return;
    var item = active.parentElement;
    var left = item.offsetLeft - list.offsetLeft;
    var right = left + item.offsetWidth;
    if (left < list.scrollLeft) list.scrollLeft = left;
    else if (right > list.scrollLeft + list.clientWidth) list.scrollLeft = right - list.clientWidth;
  }

  function initPills(root) {
    var pills = root.querySelector('[id^="BdCollectionPills-"]');
    var grid = document.getElementById('ProductGridContainer');
    if (!pills || !grid || !root.contains(grid)) return;

    revealActivePill(pills.querySelector('.bd-collection__pills'));

    // Filter pills (data-bd-facet-pill) are this collection's own URL with
    // one native filter changed: hand them to facets.js so they update like
    // any filter (AJAX grid, count, sidebar/drawer, URL + back/forward).
    // Without facets.js, or with a modifier key, they stay normal links.
    pills.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-bd-facet-pill]');
      if (!link || typeof FacetFiltersForm === 'undefined' || !document.getElementById('product-grid')) return;
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      event.preventDefault();
      pills.querySelectorAll('.bd-collection__pill').forEach(function (pill) {
        pill.classList.toggle('is-active', pill === link);
        if (pill === link) pill.setAttribute('aria-current', 'page');
        else pill.removeAttribute('aria-current');
      });
      FacetFiltersForm.renderPage(url.search.slice(1));
    });

    new MutationObserver(function () {
      // facets.js declares FacetFiltersForm as a global class (not a window property).
      var cache = typeof FacetFiltersForm !== 'undefined' ? FacetFiltersForm.filterData : null;
      if (!cache || !cache.length) return;
      var params = window.location.search.slice(1);
      var entry = cache.filter(function (item) {
        var query = item.url.slice(item.url.indexOf('?') + 1);
        return query.slice(query.indexOf('&') + 1) === params;
      }).pop();
      if (!entry) return;
      var fresh = new DOMParser().parseFromString(entry.html, 'text/html').getElementById(pills.id);
      if (!fresh || fresh.innerHTML === pills.innerHTML) return;
      var focusedLabel = pills.contains(document.activeElement) ? document.activeElement.textContent.trim() : null;
      var list = pills.querySelector('.bd-collection__pills');
      var freshList = fresh.querySelector('.bd-collection__pills');
      if (list && freshList) {
        // Same row, new items: the row keeps its horizontal scroll position.
        list.innerHTML = freshList.innerHTML;
      } else {
        pills.innerHTML = fresh.innerHTML;
        list = pills.querySelector('.bd-collection__pills');
      }
      revealActivePill(list);
      if (focusedLabel && list) {
        Array.prototype.some.call(list.querySelectorAll('.bd-collection__pill'), function (pill) {
          if (pill.textContent.trim() !== focusedLabel) return false;
          pill.focus({ preventScroll: true });
          return true;
        });
      }
    }).observe(grid, { childList: true });
  }

  function initStickyRail(root) {
    var rail = root.querySelector('.bd-collection__filters');
    if (!rail) return;

    function update() {
      var headerHeight =
        parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      var fits = railQuery.matches && rail.offsetHeight + headerHeight + 32 <= window.innerHeight;
      rail.classList.toggle('is-sticky', fits);
    }

    update();
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(rail);
  }

  function initFilterSheet(root) {
    var drawer = root.querySelector('menu-drawer.mobile-facets__wrapper');
    if (!drawer) return;

    // Inline accordions: a nested group summary keeps its native <details>
    // toggle, but never reaches MenuDrawer's handler (which would slide a
    // sub-screen in and trap focus inside that one group).
    root.addEventListener(
      'click',
      function (event) {
        if (event.target.closest('.mobile-facets__details > summary')) event.stopPropagation();
      },
      true
    );

    // Escape anywhere in the sheet closes the whole sheet and returns focus
    // to FILTER (MenuDrawer would only "close the submenu").
    root.addEventListener(
      'keyup',
      function (event) {
        if (event.key !== 'Escape' || !event.target.closest('.mobile-facets__details')) return;
        var current = root.querySelector('menu-drawer.mobile-facets__wrapper');
        if (!current || typeof current.closeMenuDrawer !== 'function') return;
        event.stopPropagation();
        current.closeMenuDrawer(event, current.mainDetailsToggle.querySelector('summary'));
      },
      true
    );

    // Tap on the dimmed backdrop (the form itself, outside the sheet) closes.
    root.addEventListener('click', function (event) {
      if (event.target.id !== 'FacetFiltersFormMobile') return;
      var current = root.querySelector('menu-drawer.mobile-facets__wrapper');
      if (!current || typeof current.closeMenuDrawer !== 'function') return;
      current.closeMenuDrawer(event, current.mainDetailsToggle.querySelector('summary'));
    });

    function setBadge(host, className, count, suffix) {
      var badge = host.querySelector('.' + className);
      if (!count) {
        if (badge) badge.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = className;
        host.appendChild(badge);
      }
      badge.innerHTML = '(' + count + '<span class="visually-hidden"> ' + suffix + '</span>)';
    }

    function decorate() {
      var sheet = root.querySelector('menu-drawer.mobile-facets__wrapper');
      if (!sheet) return;

      var close = sheet.querySelector('.mobile-facets__close');
      if (close) {
        close.setAttribute('role', 'button');
        close.setAttribute('aria-label', root.dataset.sheetClose || 'Close');
      }

      // Per group: checked boxes, or 1 when a price bound is set.
      sheet.querySelectorAll('.mobile-facets__details').forEach(function (details) {
        var host = details.querySelector('.mobile-facets__summary > div');
        if (!host) return;
        var count = details.querySelectorAll('input[type="checkbox"]:checked').length;
        if (!count) {
          var bounds = details.querySelectorAll('price-range input');
          count = Array.prototype.some.call(bounds, function (input) { return input.value !== ''; }) ? 1 : 0;
        }
        setBadge(host, 'bd-facet-count', count, 'selected');
      });

      // FILTER trigger: one per applied value, from Dawn's server-rendered
      // active-filter chips (includes a price range).
      var applied = root.querySelectorAll('.active-facets-mobile .active-facets__button').length;
      sheet.querySelectorAll('.mobile-facets__open-label').forEach(function (label) {
        setBadge(label, 'bd-filter-count', applied, 'applied');
      });

      var footer = sheet.querySelector('.mobile-facets__main > .mobile-facets__footer');
      if (!footer) return;
      var clear = footer.querySelector('.mobile-facets__clear');
      if (clear && root.dataset.sheetClear) clear.textContent = root.dataset.sheetClear;
      var view = footer.querySelector('.button--primary');
      var countSource = document.getElementById('ProductCount');
      var total = countSource ? parseInt(countSource.dataset.productCount, 10) : NaN;
      // Search: the button counts every result (pages / posts too), like the sheet header.
      if (root.dataset.sheetCount === 'results') {
        var results = countSource && countSource.querySelector('.bd-results-count');
        total = results ? parseInt(results.dataset.count, 10) : NaN;
      }
      if (view && !isNaN(total)) {
        view.textContent = (total === 1 ? root.dataset.sheetViewOne : root.dataset.sheetView).replace('[count]', total);
      }
    }

    decorate();
    root.addEventListener('change', function (event) {
      if (event.target.closest('#FacetFiltersFormMobile')) decorate();
    });
    root.addEventListener('input', function (event) {
      if (event.target.closest('#FacetFiltersFormMobile price-range')) decorate();
    });
    var grid = document.getElementById('ProductGridContainer');
    if (grid && root.contains(grid)) new MutationObserver(decorate).observe(grid, { childList: true });
  }

  var SIZE_REVEAL_SPEED = 50; // px per second - one editorial pace for every card

  function initSizeRows(root) {
    function measure(row) {
      var viewport = row.querySelector('.bd-sizes__viewport');
      var list = row.querySelector('.bd-sizes__list');
      if (!viewport || !list) return;
      var overflow = Math.ceil(list.scrollWidth - viewport.clientWidth);
      if (overflow > 1) {
        row.classList.add('is-overflowing');
        row.style.setProperty('--bd-size-shift', -(overflow + 4) + 'px');
        // Constant speed: duration grows with the distance, so every row moves
        // at the same px/s (long lists take longer, never move faster).
        row.style.setProperty('--bd-size-duration', ((overflow + 4) / SIZE_REVEAL_SPEED).toFixed(2) + 's');
      } else {
        row.classList.remove('is-overflowing');
        row.style.removeProperty('--bd-size-shift');
        row.style.removeProperty('--bd-size-duration');
      }
    }

    var observer = 'ResizeObserver' in window
      ? new ResizeObserver(function (entries) {
          entries.forEach(function (entry) { measure(entry.target); });
        })
      : null;

    function scan() {
      root.querySelectorAll('.bd-sizes').forEach(function (row) {
        measure(row);
        if (observer) observer.observe(row);
      });
    }

    scan();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scan);
    if (!observer) window.addEventListener('resize', scan);
    var grid = document.getElementById('ProductGridContainer');
    if (grid && root.contains(grid)) new MutationObserver(scan).observe(grid, { childList: true });
  }

  function overflowDebug() {
    if (window.location.hash !== '#bd-overflow') return;
    var vw = document.documentElement.clientWidth;
    var offenders = [];
    document.querySelectorAll('body *').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (!(rect.width || rect.height) || rect.right <= vw + 0.5) return; // only the right edge can scroll sideways (LTR)
      // Skip boxes clipped by an in-view scroller/clipper that also contains
      // them for positioning (an absolutely positioned box escapes a clip on
      // a non-positioned ancestor - those are exactly what we want to see).
      var abs = /absolute|fixed/.test(getComputedStyle(el).position);
      for (var a = el.parentElement; a && a !== document.body; a = a.parentElement) {
        var s = getComputedStyle(a);
        if (abs && s.position === 'static') continue;
        if (s.overflowX !== 'visible') {
          var ar = a.getBoundingClientRect();
          if (ar.right <= vw + 0.5) return;
        }
        if (abs && s.position !== 'static') abs = /absolute|fixed/.test(s.position);
      }
      {
        el.style.outline = '2px solid red';
        offenders.push(el.tagName.toLowerCase() + '.' + String(el.className).trim().split(/\s+/).slice(0, 2).join('.') + ' r=' + Math.round(rect.right));
      }
    });
    var badge = document.createElement('pre');
    badge.style.cssText = 'position:fixed;left:4px;bottom:4px;z-index:2147483647;max-width:calc(100% - 8px);max-height:40vh;overflow:auto;margin:0;padding:6px;background:#000;color:#fff;font:11px/1.3 monospace;white-space:pre-wrap';
    badge.textContent = 'scrollWidth ' + document.documentElement.scrollWidth + ' / clientWidth ' + vw + '\n' + (offenders.join('\n') || 'no element past the viewport');
    document.body.appendChild(badge);
  }

  function init(scope) {
    (scope || document).querySelectorAll('.bd-collection').forEach(function (root) {
      if (root.dataset.bdCollectionReady) return;
      root.dataset.bdCollectionReady = 'true';
      try {
        var saved = localStorage.getItem(STORAGE_KEY);
        if (/^[345]$/.test(saved)) root.dataset.density = saved;
      } catch (e) {}
      initDensity(root);
      initPills(root);
      initStickyRail(root);
      initFilterSheet(root);
      initSizeRows(root);
    });
    // Homepage Collection Tabs (.bd-size-rows): the same card size rows only.
    (scope || document).querySelectorAll('.bd-size-rows').forEach(function (root) {
      if (root.dataset.bdSizeRowsReady || root.closest('.bd-collection')) return;
      root.dataset.bdSizeRowsReady = 'true';
      initSizeRows(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
  window.addEventListener('load', overflowDebug);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
